<template>
  <v-dialog
    content-class="radius-20"
    persistent
    v-model="showDialog"
    max-width="900"
  >
    <v-card class="py-4">
      <v-card-title>
        <h2 class="my-2">
          {{ isEdit ? "Edit Sub Category" : "Add Sub Category" }}
        </h2>
      </v-card-title>

      <v-card-text>
        <v-form ref="subCategoryForm" v-model="validForm">
          <v-container>
            <v-row>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-model.number="subCategoryInfo.order"
                  :rules="[rules.required, rules.integer, rules.minVal(0)]"
                  label="Order"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="9">
                <v-text-field
                  v-model="subCategoryInfo.name"
                  :rules="[rules.required, rules.maxLen(190), rules.minLen(2)]"
                  label="Name"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <slot></slot>
      </v-card-text>

      <v-card-actions class="px-5 justify-end">
        <v-btn
          class="mx-1 px-7 radius-12"
          color="primary"
          outlined
          large
          @click="cancel"
        >
          Cancel
        </v-btn>

        <v-btn
          class="px-5 radius-12"
          color="primary"
          large
          :loading="loading"
          :disabled="!validForm || loading"
          @click="saveSubCategory"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SCMSubCategoryAddEditDialogComponent",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    subCategoryInfo: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      validForm: true,
      rules: {
        required: val => !!val || val === 0 || "This field is required",
        integer: val =>
          !val ||
          (!isNaN(Number(val)) && Number.isInteger(Number(val))) ||
          "This field's value must be integer",
        minLen(min) {
          return v =>
            ((v && v.trim()) || "").length >= min ||
            `This field can't contain less than ${min} characters`;
        },
        maxLen(max) {
          return v =>
            ((v && v.trim()) || "").length <= max ||
            `This field can't contain more than ${max} characters`;
        },
        minVal(min) {
          return v =>
            v >= min || `This field's value can't be less than ${min}`;
        }
      }
    };
  },
  computed: {
    isEdit() {
      return !!this.subCategoryInfo.id;
    },
    showDialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    saveSubCategory() {
      this.$emit("saveSubCategory", this.subCategoryInfo.id);
    },
    cancel() {
      this.showDialog = false;
      this.$emit("resetSubCategoryInfo");
    }
  },
  watch: {
    showDialog: {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.$emit("resetSubCategoryInfo");
          this.$refs.subCategoryForm.reset();
        }
      }
    }
  }
};
</script>
